import { abbrToState } from "shared/app/VerificationTemplate/slices/CountyWalkInTypeSlice/constants";
import { Option } from "shared/components/forms/Select";

export const formattedStates = (
  operatingStates: string[] | undefined,
  stateOverrides: Array<{ state: string; enrollmentType: string }>
): Option[] => {
  if (!operatingStates) return [];

  const selectedStates = stateOverrides.map((override) => override.state);
  return operatingStates
    .map((state) => ({
      label: abbrToState[state],
      value: state
    }))
    .filter((option) => !selectedStates.includes(option.value));
};

export const canAddStateOverride = (
  operatingStates: string[] | undefined,
  stateOverrides: Array<{ state: string; enrollmentType: string }>
): boolean => {
  if (!operatingStates) return false;

  const selectedStates = stateOverrides.map((override) => override.state);
  const availableStates = operatingStates.filter(
    (state) => !selectedStates.includes(state)
  );

  return (
    availableStates.length > 0 &&
    stateOverrides.every(
      (override) => override.state && override.enrollmentType
    )
  );
};
